module.exports = __webpack_public_path__ + "assets/img/download-app.7d62418b.png";